import { createApi } from '@/api/modules/utils'

const baseUrl = '/article_generation/key_word/detail'
const api = createApi(baseUrl)

// 用户相关API
export const articleWordDetailApi = {
  list: api('list', 'get'),
  delete: api('delete', 'get'),
  insert: api('insert', 'post'),
}